export default {
    namespaced: true,
    state: {
        overdue: 0
    },
    getters: {
        overdue: (state) => state.overdue
    },
    actions: {
        overdue({commit}, payload) {
            commit('SET_OVERDUE', payload)
        }
    },
    mutations: {
        'SET_OVERDUE': (state, payload) => {
            state.overdue = payload
        }
    }
}